import { MeetingAvailabilityResourceTypeMappings } from '@aa/nest/resource';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  BaseFormModalComponent,
  baseFormModalImports,
  FormModalData,
} from '../../components/base-form-modal/base-form-modal.component';
import { CoreAppState } from '../../state/core-app.state';
import { meetingAvailabilityActions } from '../../state/meeting-availability/meeting-availability.actions';
import { weekdayOptions, timeOptions } from '@aa/ts/common';

export type MeetingAvailabilityFormModel = Partial<
  MeetingAvailabilityResourceTypeMappings['createDTO']
>;
export type MeetingAvailabilityFormModalData =
  FormModalData<MeetingAvailabilityFormModel>;

@Component({
  selector: 'aa-meeting-availability-form-modal',
  standalone: true,
  imports: [...baseFormModalImports],
  templateUrl:
    '../../components/base-form-modal/base-form-modal.component.html',
  styleUrl: '../../components/base-form-modal/base-form-modal.component.scss',
})
export class MeetingAvailabilityFormModalComponent extends BaseFormModalComponent<
  MeetingAvailabilityFormModel,
  MeetingAvailabilityFormModalData
> {
  title = 'Meeting Availability';
  fields: FormlyFieldConfig[] = [
    {
      key: 'weekday',
      type: 'select',
      props: {
        label: 'Weekday',
        options: weekdayOptions.map((o, i) => ({
          label: o,
          value: i,
        })),
        required: true,
      },
    },
    {
      key: 'startTime',
      type: 'select',
      props: {
        label: 'Start Time',
        options: timeOptions.map((o) => ({ label: o, value: o })),
        required: true,
      },
    },
    {
      key: 'endTime',
      type: 'select',
      props: {
        label: 'End Time',
        options: timeOptions.map((o) => ({ label: o, value: o })),
        required: true,
      },
    },
  ];

  createAction = meetingAvailabilityActions.createItem;
  updateAction = meetingAvailabilityActions.updateItem;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    protected override readonly data: MeetingAvailabilityFormModalData,
    protected override readonly dialogRef: MatDialogRef<MeetingAvailabilityFormModalComponent>,
    protected override readonly store: Store<CoreAppState>,
  ) {
    super(data, dialogRef, store);
  }
}
